import DashboardIcon from "../../assets/icons/left-menu-icons/dashboard.svg";
import ProviderManagementIcon from "../icons/left-menu-icons/provider-management.svg";
import ServiceManagementIcon from "../icons/left-menu-icons/service-management-icon.svg";
import ContractManagement from "../../assets/icons/left-menu-icons/contract-management.svg";
import BookingAndAppointment from "../icons/left-menu-icons/calender.svg";
import PaymentBillingIcon from '../icons/left-menu-icons/payments-billings-icon.svg'
import BookingAppointmentIcon from "../../assets/icons/provider-sidebar-icons/bookings-icon.svg";
import CommunicationIcon from "../../assets/icons/provider-sidebar-icons/Communication.svg";
import ProfileManagementIcon from "../../assets/icons/provider-sidebar-icons/profile-mgmt-icon.svg";
import CommunicationManagementIcon from "../../assets/icons/communication-management-icon.svg";
import ProfileIcon from "../../assets/icons/left-menu-icons/admin-profile-mgmt-icon.svg";
import UserManagementIcon from "../../assets/icons/left-menu-icons/admin-user-mgmt-icon.svg";
import ProviderServiceManagementIcon from "../../assets/icons/left-menu-icons/provider-service-mngt-icon.svg"
import TermsOfServiceIcon from "../../assets/icons/info-icon.svg"
import OrderManagementIcon from "../../assets/icons/left-menu-icons/order-management-icon.svg"
import LeadsIcon from "../../assets/icons/left-menu-icons/assigned-leads.svg"
const icons = {
  DashboardIcon,
  ProviderManagementIcon,
  ServiceManagementIcon,
  ContractManagement,
  BookingAndAppointment,
  PaymentBillingIcon,
  BookingAppointmentIcon,
  LeadsIcon,
  TermsOfServiceIcon,
  CommunicationIcon,
  ProfileManagementIcon,
  ProviderServiceManagementIcon,
  CommunicationManagementIcon,
  ProfileIcon,
  UserManagementIcon,
  OrderManagementIcon
};

export default icons;